<template>
  <div
    class="container"
    :style="{
      background:
        'url(' +
        require('../../assets/img/' + bei_ing) +
        ') no-repeat center center',
      'background-size': '100% 100%',
    }"
  >
    <dingbu @cart-tatus="cartTatus"></dingbu>
    <div class="home_content">
      <div class="bg_color">
        <div class="w">
          <div class="inform__box">
            <div class="box__top">
              <span class="shou__ye">首页</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi2" @click.stop="toMeorder">我的订单</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi">申请开票</span>
            </div>
          </div>
          <div class="box__cntentgf">
            <div class="lian_title">
              <div class="list_name">申请开票</div>
            </div>
            <el-form>
              <div class="fapiao_text">
                <div class="apply__lists">
                  <div class="form__boxs">
                    <div class="piao__box">
                      <div class="icon_named"><span>*</span>发票类型</div>
                      <div class="span__nam" v-if="params.type == 1">
                        <div class="changed__icon">
                          <!-- <img
                            src="../../assets/img/jin_5.png"
                            alt=""
                            v-if="it_change == true"
                          /> -->
                          <img src="../../assets/img/jin_5.png" alt="" />
                        </div>
                        <div class="span__iconname">增值税纸质普通发票</div>
                      </div>
                    </div>
                    <div class="piao__box">
                      <div class="icon_named">
                        <span style="color: #fff">*</span>抬头类型
                      </div>
                      <div class="span__nam" @click.stop="changeRise(0)">
                        <div class="changed__icon">
                          <img
                            src="../../assets/img/jin_5.png"
                            alt=""
                            v-if="is_change == true"
                          />
                          <img src="../../assets/img/jin_4.png" alt="" v-else />
                        </div>
                        <div class="span__iconname">个人</div>
                      </div>
                      <div
                        class="span__nam"
                        style="margin-left: 50px"
                        @click.stop="changeRise(1)"
                      >
                        <div class="changed__icon">
                          <img
                            src="../../assets/img/jin_5.png"
                            alt=""
                            v-if="is_changd == true"
                          />
                          <img src="../../assets/img/jin_4.png" alt="" v-else />
                        </div>
                        <div class="span__iconname">企业</div>
                      </div>
                    </div>
                    <div class="piao__box">
                      <div class="icon_named"><span>*</span>发票抬头</div>
                      <div class="code_input2">
                        <el-input
                          placeholder="请输入发票抬头"
                          class="el__input_o"
                          v-model="params.title"
                        ></el-input>
                      </div>
                    </div>
                    <div class="piao__box">
                      <div class="icon_named"><span>*</span>税号</div>
                      <div class="code_input2">
                        <el-input
                          placeholder="请输入税号"
                          class="el__input_o"
                          v-model="params.tax_number"
                        ></el-input>
                      </div>
                    </div>
                    <div class="piao__box">
                      <div class="icon_named"><span>*</span>电子邮箱</div>
                      <div class="code_input2">
                        <el-input
                          placeholder="请输入电子邮箱"
                          class="el__input_o"
                          v-model="params.email"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="right__bosx">
                    <div class="ri_ruke">
                      {{ text }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="pay__botton">
                <el-button class="el_tton" @click.stop="getpolicy"
                  >确认申请</el-button
                >
              </div>
            </el-form>
          </div>
        </div>
        <dibu></dibu>
        <daohan></daohan>
      </div>
    </div>
  </div>
</template>

<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
export default {
  components: {
    daohan,
    dibu,
    dingbu
  },
  data() {
    return {
      it_change: false,
      bei_ing: this.Public.bei_ing,
      addki: [],
      page: 1,
      pageNum: 10,
      text: '电子发票与纸质发票具有同等法律效力，可支持报销入账；同时根据增值税管理办法要求，如需为企业开具增值税发票，需提供纳税人识别号或统一社会信用代码，否则该发票无法作为税收凭证。',
      total: 1,
      params: {
        study_order_id: '',
        type: '1',   //	发票类型:1=增值税普通发票,2=增值税专用发票
        title_type: '1',   //抬头类型:1=个人,2=公司 
        title: '',   //发票抬头
        tax_number: '',  //税号
        email: '',   //	电子邮箱
      },
      currentIndex: 0,
      is_changd: false,
      is_change: true,
    };
  },
  mounted() {
  },
  created() {
    let query = this.$route.query
    // console.log(query);
    this.params.study_order_id = query.id
  },
  methods: {
    changeRise(t) {
      let td = t
      if (td == 0) {
        this.is_change = true
        this.is_changd = false
        this.params.title_type = 1
      } else {
        this.is_changd = true
        this.is_change = false
        this.params.title_type = 2
      }
    },
    cartTatus(val) {
      this.addki = val.info
      this.total = val.total_num
    },
    toMeorder() {
      this.$router.push('/meorders')
      sessionStorage.setItem("orderindex", 6);
    },

    getpolicy() {
      let url = "user/studyInvoice", param = this.params;
      this.post(url, param)
        .then((res) => {
          // console.log(res);
          if (res.code == 1) {
            this.$message.success(res.msg)
            this.$router.go(-1)
          }
        })
        .catch((err) => {
          // console.log(err);
          this.$message.error(err.msg || err.data.msg)
        });
    },
  },
};
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #198bf8 !important;
  color: #fff;
  border-radius: 50%;
}
.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #ffffff;
  color: #06121e;
  min-width: 30px;
  border-radius: 2px;
}
</style>
<style scoped lang="less">
@import "../../css/policy.css";
.box__cntentgf {
  width: 100%;
  background: #ffffff;
  padding: 28px 41px 54px 29px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;

  .lian_title {
    width: 100%;

    .list_name {
      width: 140px;
      height: 34px;
      box-sizing: border-box;
      font-size: 22px;
      font-family: Source Han Sans CN, Source Han Sans CN-Bold;
      font-weight: 700;
      text-align: right;

      color: #06121e;
      line-height: 24px;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        bottom: -21px;
        left: 0;
        width: 170px;
        height: 4px;
        background: #3e8bff;
      }
    }
  }
  .fapiao_text {
    width: 100%;
    background-color: #fff;
    padding: 32px 0;
    box-sizing: border-box;

    .apply__lists {
      width: 100%;
      display: flex;
      align-items: center;
      padding: 0 80px;
      box-sizing: border-box;

      .form__boxs {
        flex: 1;
        padding: 18px;
        box-sizing: border-box;
        border-radius: 8px;

        .piao__box {
          width: 100%;
          display: flex;
          align-items: center;
          height: 40px;
          .icon_named {
            width: 130px;
            span {
              color: #ff1027;
            }
            font-size: 14px;
            font-family: Source Han Sans CN, Source Han Sans CN-Regular;
            font-weight: 400;
            text-align: left;
            color: #06121e;
            line-height: 22px;
          }
          .span__nam {
            display: flex;
            align-items: center;
            .changed__icon {
              width: 14px;
              img {
                width: 100%;
                height: 14px;
              }
            }

            .span__iconname {
              flex: 1;
              font-size: 14px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: left;
              color: #06121e;
              line-height: 40px;
              margin-left: 8px;
            }
          }

          .code_input2 {
            flex: 1;
          }
        }
      }

      .right__bosx {
        width: 450px;
        padding-left: 100px;
        box-sizing: border-box;

        .ri_ruke {
          padding: 27px 21px;
          box-sizing: border-box;
          background-color: #f9f9f9;
          opacity: 1;
          font-size: 13px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: left;
          color: #f08300;
          line-height: 24px;
        }
      }
    }
  }

  .pay__botton {
    width: 100%;
    margin-top: 40px;
    display: flex;
    justify-content: flex-end;

    .el_tton {
      width: 130px;
      height: 44px;
      background-color: #3e8bff;
      color: #fff;
      border: 0 none;
    }
  }
}
</style>